"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyPromotion = void 0;
var map_1 = __importDefault(require("lodash/map"));
var get_1 = __importDefault(require("lodash/get"));
var set_1 = __importDefault(require("lodash/set"));
var types_1 = require("./types");
var util_1 = require("./util");
var mealDeal_1 = require("./mealDeal");
// Check if we would like to have discount for meal deals as well
var getPossiblyDiscountedProducts = function (products, promotion) { return !promotion.bundleDiscountOnly
    ? products
    : products.filter(function (product) { return !util_1.Bundle.hasMealDeal(product); }); };
function productIsInEligibleMealDeal(product, eligibleItemsUUIDs) {
    return eligibleItemsUUIDs.includes((0, get_1.default)(product, 'deal.uuid'));
}
function applyPromotionToOrder(products, promotion) {
    var excludedProductUUIDs = (0, map_1.default)(promotion.excludedProducts, 'extProductUUID');
    var filteredProducts = getPossiblyDiscountedProducts(products, promotion);
    var discountedProducts = filteredProducts.filter(function (product) {
        var dealUUID = (0, get_1.default)(product.deal, 'uuid', '');
        return !(excludedProductUUIDs.includes(product.uuid) ||
            excludedProductUUIDs.includes(dealUUID));
    });
    return discountedProducts.map(function (product) { return (__assign(__assign({}, product), { promotion: (0, util_1.minimalPromotion)(promotion) })); });
}
function applyPromotionToMostExpensive(products, promotion) {
    var eligibleProductUUIDs = (0, map_1.default)(promotion.productPromotions, 'extProductUUID');
    var filteredProducts = getPossiblyDiscountedProducts(products, promotion);
    var discountedProducts = filteredProducts.filter(function (product) {
        var dealUUID = (0, get_1.default)(product, ['deal', 'uuid']);
        return (eligibleProductUUIDs.includes(product.uuid) ||
            eligibleProductUUIDs.includes(dealUUID));
    });
    var mostExpensiveDeal = mealDeal_1.MealDeal.getMostExpensive(discountedProducts.filter(function (product) { return productIsInEligibleMealDeal(product, eligibleProductUUIDs); }));
    var mostExpensiveBundle = util_1.Bundle.getMostExpensive(discountedProducts.filter(function (product) { return !productIsInEligibleMealDeal(product, eligibleProductUUIDs); }));
    var mostExpensiveBasketUUID = (0, get_1.default)(mostExpensiveDeal, 'price', 0) >=
        (0, get_1.default)(mostExpensiveBundle, 'finalPrice', 0)
        ? mostExpensiveDeal === null || mostExpensiveDeal === void 0 ? void 0 : mostExpensiveDeal.basketUUID
        : mostExpensiveBundle.basketUUID;
    return products
        .map(function (product) {
        var dealBasketUUID = (0, get_1.default)(product, 'deal.basketUUID');
        var bundleBasketUUID = (0, get_1.default)(product, 'basketUUID');
        var appliesTo = dealBasketUUID && mostExpensiveBasketUUID === dealBasketUUID
            ? 'deal'
            : bundleBasketUUID && mostExpensiveBasketUUID === bundleBasketUUID
                ? 'bundle'
                : null;
        if (!appliesTo) {
            return null;
        }
        var promotionDestination = appliesTo === 'deal'
            ? ["deal", "promotion"]
            : ['promotion'];
        return (0, set_1.default)(product, promotionDestination, (0, util_1.minimalPromotion)(promotion));
    })
        .filter(Boolean);
}
function applyPromotionToBundles(products, promotion) {
    var eligibleProductUUIDs = (0, map_1.default)(promotion.productPromotions, 'extProductUUID');
    var filteredProducts = getPossiblyDiscountedProducts(products, promotion);
    var eligibleProducts = filteredProducts.filter(function (product) {
        var dealUUID = (0, get_1.default)(product, ['deal', 'uuid']);
        return (eligibleProductUUIDs.includes(product.uuid) ||
            eligibleProductUUIDs.includes(dealUUID));
    });
    return eligibleProducts.map(function (eligibleProduct) {
        var deal = eligibleProduct.deal;
        var isDealElgibile = deal && eligibleProductUUIDs.includes(deal.uuid);
        var promotionDestination = isDealElgibile ? ['deal', 'promotion'] : ['promotion'];
        return (0, set_1.default)(eligibleProduct, promotionDestination, (0, util_1.minimalPromotion)(promotion));
    });
}
var applyPromotion = function (products, promotion) {
    var _a;
    var applyFunctions = (_a = {},
        _a[types_1.PromoAppliesTo.Order] = applyPromotionToOrder,
        _a[types_1.PromoAppliesTo.AssocBundles] = applyPromotionToBundles,
        _a[types_1.PromoAppliesTo.AssocMostExpensive] = applyPromotionToMostExpensive,
        _a);
    return applyFunctions[promotion.appliesTo](products, promotion);
};
exports.applyPromotion = applyPromotion;
